import { createRouter, createWebHistory } from 'vue-router';
import routes from '../routes.js';

/**
 * @param {string|Array<string>} value
 * @returns {string}
 */
export function first(value) {
  return Array.isArray(value) ? value[0] : value;
}

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
